import styled from "styled-components/macro";
import { Helmet } from "react-helmet-async";
import { Box, Breadcrumbs as MuiBreadcrumbs, Divider as MuiDivider, Grid, Typography } from "@material-ui/core";
// @ts-ignore
import { marked } from 'marked';
import { PDFDownloadLink, Document } from "@react-pdf/renderer";
import { spacing } from "@material-ui/system";
import { useTranslation } from "react-i18next";
import { QueryClient, QueryClientProvider } from "react-query";
import { StoplightProject } from "@stoplight/elements-dev-portal";
import "@stoplight/elements-dev-portal/styles.min.css";
import { Search } from "../pages/property-page-components/controllers/SearchTocControl";
import { i18n } from "../../translations/i18n";
import React, { useState } from "react";
import { GradientButton } from "../pages/property-page-components/PropertyForm";
import { getStoplightContentIdsByProject, getStoplightNodeById } from "../../services/stoplightService";
import getDocument from "./parserHtmlToPdf/getDocument";
const Divider = styled(MuiDivider)(spacing);

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const MainWrapper = styled.main`
  flex: 1 0 0;
  overflow: hidden;
  background-color: #1e2634;
  color: #1e2634;
  min-width: 1000px;
`;


const getStoplightProjectId = (currentLanguage: string) => {
  switch (currentLanguage) {
    case 'en':
      return `${process.env.REACT_APP_STOPLIGHT_PROJECT_ID}`;
    case 'sv' || 'sv-SE':
      return `${process.env.REACT_APP_STOPLIGHT_PROJECT_ID_SWE}`;
    default:
      return `${process.env.REACT_APP_STOPLIGHT_PROJECT_ID}`;
  }
}

function AMSToc() {
  const queryClient = new QueryClient();

  const currentLanguage = i18n.language;

  const stoplightProjectId = getStoplightProjectId(currentLanguage);

  if (stoplightProjectId) {
    return (
      <QueryClientProvider client={queryClient}>
        <MainWrapper>
          <nav className="topnav">
            <Search projectIds={[stoplightProjectId]} />
          </nav>
          <StoplightProject
            projectId={stoplightProjectId}
            hideTryIt={true}
            hideMocking={true}
            router="memory"
            collapseTableOfContents={true}
          />
        </MainWrapper>
      </QueryClientProvider>
    );
  }
  return null;
}

function DocumentationPage() {
  const { t } = useTranslation();
  const [autoDownload, setAutoDownload] = useState(false)
  const [isDownloadDocument, setIsDownloadDocument] = useState(false)
  const [newDocument, setNewDocument] = useState<any>(<Document/>)

  const downloadDocument = async (e: any) => {
    e.preventDefault()
    const stoplightProjectId = getStoplightProjectId(i18n.language);
    getStoplightContentIdsByProject(stoplightProjectId)
      .then(async (ids: string[]) => {
        const promises = []
        for (const id of ids) {
          promises.push(getStoplightNodeById(stoplightProjectId, id))
        }
        const results = await Promise.all(promises);
        return results.map((i) => (
          marked.parse(i.data.data
            .replace(/<!--[\s\S]*?-->/g, '')
            .replace(/tags:[\s\S]*?]/g, '')
            .replace(/stoplight-id[\s\S]*?xi/g, '')
          )
        ))
      }).then((results) => {
        setNewDocument(getDocument(results))
        setIsDownloadDocument(true)
      })
  }

  const simulateClick = (e: any) => {
    if (!autoDownload) {
      if (e) e.click()
      setAutoDownload(true)
    }
  }

  const getButtonForDownloadLink = (loading: boolean) => {
    if (loading) {
      return <Typography>{`${t('documentationPage_loadingDocument')}...`}</Typography>
    }

    if (isDownloadDocument) {
      return (
        <GradientButton ref={simulateClick}>
          {(t('documentationPage_downloadDocument'))}
        </GradientButton>
      )
    } else {
      return (
        <GradientButton onClick={downloadDocument}>
          {(t('documentationPage_downloadDocument'))}
        </GradientButton>
      )
    }

  }

  return (
    <Box p={12}>
      <Box display={'flex'} justifyContent={'space-between'}>
        <Helmet title={t("DocumentationPage_tabtitle")} />
        <Typography variant="h3" gutterBottom display="inline">
          {t("DocumentationPage_pageTitle")}
        </Typography>
          <PDFDownloadLink
            document={newDocument}
            fileName={"AMS_documentation"}
          >
            {({loading }) => getButtonForDownloadLink(loading)}
          </PDFDownloadLink>
      </Box>

      <Divider my={6} />

      <Grid container spacing={6}>
        <Grid item xs={12} style={{overflowX: 'auto'}}>
          <AMSToc />
        </Grid>
      </Grid>
    </Box>
  );
}

export default DocumentationPage;
